import React from 'react';
import {
  Button,
  Modal,
  ModalProps,
  //Radio,
  Row,
  Space,
} from 'antd';

export enum DownloadFileType {
  Merge = 1,
  Independ = 2,
};

type Props = ModalProps & {
  doDownloadAction: Function;
  notMergeable?: boolean;
};

const DownloadFileOptionsDialog = (props: Props) => {
  const { useState } = React;
  const [attrs, setAttrs] = useState<StringKAnyVPair>({});
  const [downloadType, setDownloadType] = useState<number>();
  const [inited, setInited] = useState(false);

  const dialogFooter = () => {
    return (
      <Row justify="end">
        <Space>
          <Button onClick={onCancel}>
            Cancel
          </Button>
          {/*<Button
            disabled={!isDownloadTypeSelected()}
            onClick={onOk}
            type="primary"
          >
            OK
          </Button>*/}
        </Space>
      </Row>
    );
  };

  const handleDownload = (dt: any) => {
    props.doDownloadAction(dt);
    // @ts-ignore
    onCancel();
  };

  // eslint-disable-next-line
  const isDownloadTypeSelected = () => {
    return typeof downloadType === 'number';
  };

  const onCancel = (evt: any) => {
    if (props.onCancel) props.onCancel(evt);
  };

  // eslint-disable-next-line
  const onDownloadTypeChange = (evt: any) => {
    //console.log(evt.target.value, '<-');
    setDownloadType(evt.target.value);
  };

  // eslint-disable-next-line
  const onOk = (evt: any) => {
    props.doDownloadAction(downloadType);
    onCancel(evt);
  };

  React.useEffect(() => {
    if (!inited) {
      const ps = { ...props };

      setAttrs(ps);
      setInited(true);
    }
  }, [inited, props]);

  return (<>
    <Modal
      { ...attrs }
      footer={dialogFooter()}
    >
      {/*<Radio.Group onChange={onDownloadTypeChange} value={downloadType}>
        <Space direction="vertical">
          <Radio value={DownloadFileType.Merge}>Download merged file</Radio>
          <Radio value={DownloadFileType.Independ}>Download individual files</Radio>
        </Space>
      </Radio.Group>*/}
      <Row
        justify="center"
        style={{width: '100%'}}
      >
        <Space direction="vertical">
          <Button
            disabled={props.notMergeable}
            onClick={() => handleDownload(DownloadFileType.Merge)}
            style={{width: '100%'}}
          >
            Download merged file
          </Button>
          <Button
            onClick={() => handleDownload(DownloadFileType.Independ)}
            style={{width: '100%'}}
          >
            Download individual files
          </Button>
        </Space>
      </Row>
    </Modal>
  </>);
};

export default DownloadFileOptionsDialog;
